import api from './api';

export async function fetchNotificationInbox(limit = 40) {
  const res = await api.get('/notifications/inbox', { params: { limit } });
  return res.data || { unread_count: 0, counts: {}, items: [] };
}

/** One page of the full history; pass the previous page's next_cursor to get the next. */
export async function fetchNotificationHistory({ cursor, ...filters } = {}) {
  const params = Object.fromEntries(Object.entries({ ...filters, cursor }).filter(([, value]) => value !== undefined && value !== null && value !== ''));
  const res = await api.get('/notifications', { params });
  return res.data || { data: [], next_cursor: null, unread_count: 0 };
}

export async function markNotificationRead(notificationId) {
  await api.post(`/notifications/${notificationId}/read`);
}

export async function markNotificationUnread(notificationId) {
  await api.post(`/notifications/${notificationId}/unread`);
}

export async function markAllNotificationsRead() {
  await api.post('/notifications/read-all');
}

/** Farm categories the user can get ({ categories, muted }). */
export async function fetchNotificationPreferences() {
  const res = await api.get('/notifications/preferences');
  return res.data || { categories: [], muted: [] };
}

export async function updateNotificationPreferences(muted) {
  const res = await api.put('/notifications/preferences', { muted });
  return res.data;
}
